bz_app.factory('contentInjectService', [
  '$compile',
  function ($compile) {
    return {
      neighborhoodProjects: function ($scope) {
        // neighborhood map
        angular
          .element('.permit-map-wrapper')
          .prepend(
            '<div id="permit_map" permit-map ' +
              'properties="' +
              encodeURI(JSON.stringify($scope.neighborhoodProperties)) +
              '"' +
              'latitude="' +
              $scope.property.latitude +
              '"' +
              'longitude="' +
              $scope.property.longitude +
              '"' +
              'location-id="' +
              $scope.property.location_id +
              '"' +
              'zoom="17"' +
              'limit="30">' +
              '</div>'
          )

        $compile(angular.element('#permit_map'))($scope)

        var neighborhood_projects = $compile(
          '<div neighborhood-projects property-id="property.id" version="v1" properties="neighborhoodPropertiesDetails" class="property-neighborhood-items container"></div>'
        )($scope)
        angular
          .element('.property-neighborhood-items-container')
          .append(neighborhood_projects)
      },
      projectForm: function ($scope) {
        var project_form = $compile(
          '<div project-form title-label="I need help with..." urgency-label="When?" referral-source="property about BZ" css-class="widget-modern" submit-button-text="get started" submit-button-css-class="modern-dark-blue-button modern-small-button"></div>'
        )($scope)
        angular.element('.project-form-container').append(project_form)
      },
      photoRibbon: function ($scope) {
        var photo_ribbon = $compile(
          '<div photo-ribbon class="photo-ribbon" property-id="property.id" photos-data="photosData"></div>'
        )($scope)
        angular.element('.photo-ribbon-container').append(photo_ribbon)
      },
    }
  },
])
